import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.discoverStepTwoLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.discoverStepTwoLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.discoverStepTwoLevels.data.discoverStepTwoLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
